import React, { createContext, useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./Toast.css";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    message: "",
    type: "success",
    visible: false,
  });

  const showToast = (message, type = "success", duration = 3000) => {
    setToast({ message, type, visible: true });

    setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, duration);
  };

  // Render toast in a portal to ensure it's always on top
  const toastNode = toast.visible ? (
    <div className={`toast ${toast.type}`}>{toast.message}</div>
  ) : null;

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {ReactDOM.createPortal(toastNode, document.body)}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
